import { IXC_ASSETS_V1_ASSET_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-assets-v1-asset-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcAssetsV1AssetStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../util/entity-status-variants';

interface AssetStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcAssetsV1AssetStatus | undefined;
}

export function AssetStatusPill({ isPending, status, ...props }: AssetStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_ASSETS_V1_ASSET_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcAssetsV1', enumName: 'IxcAssetsV1AssetStatus', value: status }} />
    </Pill>
  );
}
